// extracted by mini-css-extract-plugin
module.exports = {"container":"ChapterTitle_container__3lFQl"};